import React, { useEffect, useState } from "react";
import { FrameItem } from "../QrFrameItems";
import QrFrameWrapper from "../QrFrameWrapper";
import { Col, Row } from "react-bootstrap";
import useFrames from "../../../../../hooks/useFrames";
import useWindowSize from "../../../../../hooks/useWindowSize";
import moment from "moment";
import classNames from "classnames";
import { setActivePremadeTemplateId } from "../../../../../redux/slices/preMadeTemplates";
import { useDispatch } from "react-redux";
import { qrResetSettings } from "../../../../../redux/slices/qrSettings";

function HolidayFrameBlock({
  title,
  categories,
  handleViewMore,
  setFrame,
  setFrameTransform,
  setFrameTransformText,
  frame,
}) {
  const { frameConfigs, holidayDates, framesCategories } = useFrames();
  const { isDesktop } = useWindowSize();
  const dispatch = useDispatch();
  const [filteredFrames, setFilteredFrames] = useState([]);
  const userCountry =
    document.querySelector("#user-data")?.dataset?.country || "";

  const indexesAllHolidays = Object.keys(categories)
    .map((category) => framesCategories.indexOf(category))
    .filter((index) => index !== -1);

  const categoryCount = frameConfigs.filter((item) =>
    indexesAllHolidays.includes(item.categoryId)
  ).length;

  const countMore = isDesktop
    ? categoryCount > 5
      ? categoryCount - 5
      : 0
    : categoryCount > 2
    ? categoryCount - 2
    : 0;

  const filterHolidays = () => {
    let frameCategories = [];
    const currentDate = moment();

    Object.entries(holidayDates).forEach((item) => {
      let start = moment(item[1].start, "DD.MM.YYYY").startOf("D");
      let end = moment(item[1].end, "DD.MM.YYYY").endOf("D");
      const country = item[1].country;
      const yearSwitch = item[1]?.yearSwitch;
      const isHolidayDate = yearSwitch
        ? currentDate.isAfter(start) || currentDate.isBefore(end)
        : currentDate.isBetween(start, end);

      if (isHolidayDate && (userCountry === country || country === "")) {
        frameCategories.push(item[0]);
      }
    });

    // if there is no holiday on the current date, display the nearest last holiday
    if (!frameCategories.length) {
      let closestHolidayDate = null;
      Object.entries(holidayDates).forEach(([key, value]) => {
        const endDate = moment(value.end, "DD.MM.YYYY");
        if (endDate.isBefore(currentDate)) {
          if (
            closestHolidayDate === null ||
            (endDate.diff(currentDate) > closestHolidayDate.diff(currentDate) &&
              (userCountry === value.country || value.country === ""))
          ) {
            closestHolidayDate = endDate;
            frameCategories = [key];
          }
        }
      });
    }

    // sort holidays, holidays by country have higher priority, holiday start date has higher priority
    frameCategories.sort((a, b) => {
      const aCountryLength = holidayDates[a].country.length;
      const bCountryLength = holidayDates[b].country.length;

      if (aCountryLength !== bCountryLength) {
        return aCountryLength ? -1 : 1;
      }

      const aStartDate = moment(holidayDates[a].start, "DD.MM.YYYY");
      const bStartDate = moment(holidayDates[b].start, "DD.MM.YYYY");

      return aStartDate.isBefore(bStartDate)
        ? -1
        : bStartDate.isBefore(aStartDate)
        ? 1
        : 0;
    });
    const indexes = framesCategories.indexOf(frameCategories[0]);
    setFilteredFrames([indexes]);
  };

  useEffect(() => {
    filterHolidays();
  }, []);

  return (
    <>
      <div className="mb-2 mb-lg-3 fw-bold fs-6 fs-lg-8 d-flex align-items-baseline">
        {title}
      </div>
      <Row className="g-cards">
        {frameConfigs
          .filter((item) => filteredFrames.includes(item.categoryId))
          .slice(0, isDesktop ? 5 : 2)
          .map((i) => {
            return (
              <Col xs={4} key={i.id}>
                <FrameItem
                  onClick={() => {
                    dispatch(qrResetSettings());
                    setFrame(i.name);
                    setFrameTransform(i.transformQr);
                    setFrameTransformText(i.transformFrameText);
                    dispatch(setActivePremadeTemplateId(null));
                  }}
                  className={classNames(
                    "d-flex justify-content-center align-items-center border rounded-1 p-2 h-100",
                    {
                      "border-primary": i.name === frame,
                      "border-border-gray": i.name !== frame,
                    }
                  )}
                >
                  <QrFrameWrapper
                    frame={i.name}
                    frameColor={"#727271"}
                    isTransformFrameWithTextTemplate={false}
                  />
                </FrameItem>
              </Col>
            );
          })}
        {countMore > 0 && (
          <Col xs={4}>
            <FrameItem
              className="d-flex justify-content-center align-items-center border rounded-1 p-2 h-100 flex-column fs-4 py-4 cursor-pointer"
              onClick={() => {
                handleViewMore(filteredFrames[0]);
              }}
            >
              +{countMore}
            </FrameItem>
          </Col>
        )}
      </Row>
    </>
  );
}

export default HolidayFrameBlock;
